import type { NextRequest } from "next/server";
import { PETROMIN_USER_COOKIE_NAME } from "@/lib/authSession";

/** Parses `customerId` from the `petromin_user` cookie (Route Handlers only). */
export function parseCustomerIdFromPetrominUserCookie(
  raw: string | undefined
): string | null {
  if (!raw?.trim()) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    try {
      parsed = JSON.parse(decodeURIComponent(raw));
    } catch {
      return null;
    }
  }
  if (!parsed || typeof parsed !== "object") return null;
  const rec = parsed as Record<string, unknown>;
  const id =
    (typeof rec.customerId === "string" && rec.customerId.trim()) ||
    (typeof rec.customer_id === "string" && rec.customer_id.trim()) ||
    "";
  return id || null;
}

export function getCustomerIdFromRequest(request: NextRequest): string | null {
  const v = request.cookies.get(PETROMIN_USER_COOKIE_NAME)?.value;
  return parseCustomerIdFromPetrominUserCookie(v);
}
export function setUTMCookie(
  key: string,
  value: string | number,
  maxAgeSeconds?: number
): void {
  if (typeof window !== 'undefined') {
    let cookieStr = `${key}=${encodeURIComponent(
      value
    )}; path=/; sameSite=Lax`;

    if (maxAgeSeconds) {
      cookieStr += `; max-age=${maxAgeSeconds}`;
    }

    // Optional: Add Secure flag if running on HTTPS
    if (window.location.protocol === 'https:') {
      cookieStr += '; secure';
    }

    document.cookie = cookieStr;
  }
}

export function getUTMCookie(key: string): string {
  if (typeof window === 'undefined') return '';

  const cookies = document.cookie
    .split('; ')
    .reduce((acc: Record<string, string>, cookie) => {
      const [cookieKey, cookieValue] = cookie.split('=');
      acc[cookieKey] = decodeURIComponent(cookieValue || '');
      return acc;
    }, {});

  return cookies[key] ?? '';
}